import styled from 'styled-components';
import constants from '../../../abstracts/constants';
import { paleBlue, prussianBlue } from '../../../abstracts/colours';

export const StyledChipContainer = styled.div`
  display: inline-block;
  font-size: ${constants.SMALL};
  font-weight: 600;
  font-family: ${constants.sourceSansPro};
  text-align: left;
  color: ${prussianBlue};
  background-color: ${paleBlue};
  border-radius: 15.5px;
  padding: 7px 16px;
  margin: 0 24px 0 0;
  box-sizing: content-box;
`;
